<template>
  <div class="product-item">
    <div class="product-info">
      <div class="info-left">
        <div class="product-name">
          <div
            class="product-type"
            :style="{
              background: visaTypeMap[product.visa_type]
                ? visaTypeMap[product.visa_type].bgColor
                : visaTypeMap.qita.bgColor,
            }"
          >
            {{ product.visa_type }}
          </div>
          <span class="name-text">{{ product.product_name_short }}</span>
        </div>
        <div class="other-info">
          <div class="other-info-item">
            入境次数&nbsp;<span v-html="entryCN"></span>
          </div>
          <div class="other-info-item">
            有效期&nbsp;<span v-html="validityPeriodCN"></span>
          </div>
        </div>
      </div>
      <div class="info-right">
        <div class="price-box">
          <div class="price-num">
            <span class="currency">￥</span>
            <span class="price">{{ product.sell_price / 100 }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="handle-box">
      <div class="btn" @click="handleCopyProductInfo">
        <img
          class="icon"
          src="../../../../../../assets/imgs/work-wx/country/icon-copy.png"
          alt=""
        />
        商品信息
      </div>
      <div class="btn" @click="showMaterialDialog = true">
        <img
          class="icon"
          src="../../../../../../assets/imgs/work-wx/country/icon-copy.png"
          alt=""
        />
        资料清单
      </div>
    </div>

    <product-mateial-detail-dialog
      :visible.sync="showMaterialDialog"
      :product="product"
    ></product-mateial-detail-dialog>
  </div>
</template>

<script>
import productService from '../../../services/product-service.js';
import { visaFormMap } from '../../../consts/product-const.js';
import ProductMateialDetailDialog from './product-mateial-detail-dialog.vue';

export default {
  components: {
    ProductMateialDetailDialog,
  },
  props: {
    product: Object,
  },
  data() {
    return {
      visaTypeMap: {
        旅游签: {
          bgColor:
            'linear-gradient(135deg,rgba(123,179,242,1) 0%,rgba(84,148,221,1) 100%)',
        },
        商务签: {
          bgColor:
            'linear-gradient(135deg,rgba(94,211,187,1) 0%,rgba(61,187,162,1) 100%)',
        },
        探亲访友签: {
          bgColor:
            'linear-gradient(135deg,rgba(161,154,223,1) 0%,rgba(130,122,202,1) 100%)',
        },
        短期学习签: {
          bgColor:
            'linear-gradient(135deg,rgba(251,143,143,1) 0%,rgba(240,99,99,1) 100%)',
        },
        医疗签: {
          bgColor:
            'linear-gradient(135deg,rgba(238,214,104,1) 0%,rgba(237,184,80,1) 100%)',
        },
        访问签: {
          bgColor:
            'linear-gradient(135deg,rgba(116,208,247,1) 0%,rgba(72,185,233,1) 99%)',
        },
        免签: {
          bgColor:
            'linear-gradient(135deg,rgba(252,187,131,1) 0%,rgba(237,148,71,1) 100%)',
        },
        落地签: {
          bgColor:
            'linear-gradient(135deg,rgba(246,154,209,1) 0%,rgba(235,124,191,1) 100%)',
        },
        过境签: {
          bgColor:
            'linear-gradient(135deg,rgba(132,218,228,1) 0%,rgba(87,198,211,1) 100%)',
        },
        香港L签过关服务: {
          bgColor:
            'linear-gradient(135deg,rgba(162,221,141,1) 0%,rgba(129,196,106,1) 100%)',
        },
        入台证: {
          bgColor:
            'linear-gradient(135deg,rgba(158,181,229,1) 0%,rgba(94,134,217,1) 100%)',
        },
        展会签: {
          bgColor:
            'linear-gradient(135deg,rgba(217,179,140,1) 0%,rgba(180,144,106,1) 100%)',
        },
        EVUS登记: {
          bgColor:
            'linear-gradient(135deg,rgba(252,187,131,1) 0%,rgba(237,148,71,1) 100%)',
        },
        公证认证: {
          bgColor:
            'linear-gradient(135deg,rgba(246,154,209,1) 0%,rgba(235,124,191,1) 100%)',
        },
        公证: {
          bgColor:
            'linear-gradient(135deg,rgba(132,218,228,1) 0%,rgba(87,198,211,1) 100%)',
        },
        签注续签: {
          bgColor:
            'linear-gradient(135deg,rgba(162,221,141,1) 0%,rgba(129,196,106,1) 100%)',
        },
        '国际驾照（KIDA）': {
          bgColor:
            'linear-gradient(135deg,rgba(158,181,229,1) 0%,rgba(94,134,217,1) 100%)',
        },
        香港驾照: {
          bgColor:
            'linear-gradient(135deg,rgba(217,179,140,1) 0%,rgba(180,144,106,1) 100%)',
        },
        入金证: {
          bgColor:
            'linear-gradient(135deg,rgba(252,187,131,1) 0%,rgba(237,148,71,1) 100%)',
        },
        香港签注续签: {
          bgColor:
            'linear-gradient(135deg,rgba(246,154,209,1) 0%,rgba(235,124,191,1) 100%)',
        },
        qita: {
          bgColor:
            'linear-gradient(135deg,rgba(246,154,209,1) 0%,rgba(235,124,191,1) 100%)',
        }, // 此处故意用英文区分
      },
      showMaterialDialog: false,
    };
  },
  computed: {
    entryCN() {
      if (!this.product) return '';
      const cn = productService.getEntryCountCN(
        this.product.entry_count_n,
        this.product.entry_count_unit,
      );
      // 需要把数字加粗，所以替换一下
      const reg = new RegExp('\\d+', 'g');
      return cn.replace(reg, (text) => `<span class="num">${text}</span>`);
    },
    validityPeriodCN() {
      if (!this.product) return '';
      const cn = productService.getValidityPeriodCN(
        this.product.validity_period_n,
        this.product.validity_period_unit,
      );
      // 需要把数字加粗，所以替换一下
      const reg = new RegExp('\\d+', 'g');
      return cn.replace(reg, (text) => `<span class="num">${text}</span>`);
    },
  },
  created() {},
  methods: {
    handleCopyProductInfo() {
      const copyText = `您好，以下为签证商品的详细信息：
${this.product.visa_country_name}-${this.product.product_name}
${this.product.visa_type}&${visaFormMap[this.product.visa_form]}，办理价格：￥${
        this.product.sell_price / 100
      }，${this.product.need_urgent ? '支持' : '不支持'}加急
办理时长：${this.product.need_days_detail}`;
      console.log('复制的内容', copyText);
      ww.setClipboardData({
        data: copyText,
        success() {},
      });
    },
  },
};
</script>

<style lang="less" scoped>
.product-item {
  background: #fff;
  border-bottom: 1px solid #e9eef2;
  padding: 12px;
  display: flex;

  &:last-child {
    border-bottom: none;
  }
  .product-info {
    flex-grow: 1;
    overflow: hidden;
    display: flex;
    align-items: center;
    padding-right: 12px;
    .info-left {
      flex-grow: 1;
      overflow: hidden;
      .product-name {
        color: #2f333d;
        font-size: 0;
        .product-type {
          height: 18px;
          padding: 0 4px;
          font-size: 12px;
          line-height: 1;
          color: #fff;
          display: inline-flex;
          align-items: center;
          justify-self: center;
          vertical-align: top;
          margin-top: 1px;
          margin-right: 4px;
          border-radius: 1px;
        }

        .name-text {
          font-size: 14px;
          line-height: 20px;
          font-weight: 600;
        }
      }
      .other-info {
        margin-top: 8px;
        display: flex;
        align-items: center;
        .other-info-item {
          color: #91999f;
          font-size: 12px;
          line-height: 1;
          margin-right: 16px;
          /deep/ .num {
            color: #5f666e;
          }
        }
      }
    }
    .info-right {
      flex-shrink: 0;
      margin-left: 12px;
      .price-box {
        display: flex;
        align-items: center;
        .price-num {
          display: flex;
          align-items: baseline;
          .currency {
            color: #ff8033;
            font-size: 12px;
            font-weight: 600;
          }

          .price {
            color: #ff8033;
            font-size: 18px;
            font-weight: 600;
          }
        }
      }
    }
  }
  .handle-box {
    flex-shrink: 0;
    padding-left: 12px;
    border-left: 1px dashed #ededed;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .btn {
      padding: 0 12px;
      height: 24px;
      border-radius: 1px;
      border: 1px solid #599fff;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #599fff;
      font-size: 12px;
      cursor: pointer;
      .icon {
        width: 12px;
        height: 12px;
      }
      & + .btn {
        margin-top: 12px;
      }
    }
  }
}
</style>
